import React from 'react';
import GeneralStatus from '../../GeneralStatus';
import { BattlePlayerRankCorner } from '../../pvp/battlePlayerRankCorner';
import { MOBILE_BATTLE_DOCK_LIFT_PX } from './mobileBattleLayoutOffsets';

/**
 * Mobile Player Avatar (General) Component
 * Positioned at bottom-left, above the resign button
 */
export const MobilePlayerAvatar = ({
  you,
  playerDamageFlash,
  playerRank,
  playerPvpLadder,
  selectedGeneral,
  avatars,
  getAvatarImage,
  getDamageFlashStyles,
  shouldMirrorAvatar,
  getRankStyle,
  calculateFactionFromStrategy,
  getTranslatedFactionName,
  yourTurn,
  barrierVisualResetKey = null,
}) => {
  return (
    <div className="player-avatar-container-mobile" style={{ 
      position: "absolute", 
      left: "5px",
      bottom: `${45 + MOBILE_BATTLE_DOCK_LIFT_PX}px`,
      zIndex: 1000,
      transform: "scale(0.4)",
      transformOrigin: "bottom left"
    }}>
      <div style={{ position: "relative", display: "inline-block" }}>
        <GeneralStatus
          health={you.health}
          intelligenceLeft={you.intelligence}
          intelligenceTotal={you.maxIntelligence}
          barriersRemoved={you.barriersRemoved ?? []}
          barrierVisualResetKey={barrierVisualResetKey}
          damageFlash={playerDamageFlash}
          playerCompact={true}
          factionName={calculateFactionFromStrategy(you.strategy)}
          translatedFactionName={getTranslatedFactionName(calculateFactionFromStrategy(you.strategy))}
          isActiveTurn={yourTurn}
        />
        <div style={{ position: "relative", width: "180px", height: "180px", display: "inline-block", overflow: "visible" }}>
          <img 
            src={getAvatarImage(selectedGeneral)} 
            alt="Player General"
            data-zone="player_general"
            style={{ 
              width: "100%", 
              height: "100%", 
              objectFit: "contain",
              display: "block",
              ...getDamageFlashStyles(playerDamageFlash),
              transform: shouldMirrorAvatar(selectedGeneral, 'left', avatars) ? 'scaleX(-1)' : 'none',
              borderRadius: '8px'
            }} 
          />
          <BattlePlayerRankCorner
            playerRank={playerRank}
            playerPvpLadderRow={playerPvpLadder}
            getRankStyle={getRankStyle}
          />
        </div>
      </div>
    </div>
  );
};

export default MobilePlayerAvatar;

